import Vue from 'vue';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { split } from 'apollo-link';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import VueApollo from 'vue-apollo';
import store from '@/store';

// Import fetch polyfill
import 'whatwg-fetch';

export const API_HOST = process.env.VUE_APP_API_HOST;
export const WS_HOST = process.env.VUE_APP_WS_HOST;

// Install the vue plugin
Vue.use(VueApollo);

// Call this in the Vue app file
export const createProvider = () => {
  // Create the HTTP link for apollo
  const httpLink = new HttpLink({
    uri: API_HOST,
  });

  // Create an auth link for managing authentication
  const authLink = setContext((_: any, { headers }: any) => {
    const token = store.getters['auth/token'];
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  });

  // Create a websocket link
  const wsLink = new WebSocketLink({
    uri: WS_HOST,
    options: {
      reconnect: true,
    },
  } as WebSocketLink.Configuration);

  // Create a new link based on operation
  const link = split(
    ({ query }: any) => {
      const { kind, operation }: { kind: string, operation?: string } = getMainDefinition(query);
      return kind === 'OperationDefinition' && operation === 'subscription';
    },
    wsLink,
    authLink.concat(httpLink),
  );

  // Create the apollo client
  const cache =  new InMemoryCache();
  const apolloClient = new ApolloClient({
    link,
    connectToDevTools: true,
    cache,
  });

  // Create a new apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    // errorHandler: (err: any) => {
    //   // tslint:disable-next-line:no-console
    //   console.log(
    //     '%cGraphQL Error',
    //     'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
    //     err.message,
    //   );
    // },
  });

  return apolloProvider;
};

// // Manually call this when user log in
// export async function onLogin (apolloClient, token) {
//   localStorage.setItem(AUTH_TOKEN, token)
//   if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
//   try {
//     await apolloClient.resetStore()
//   } catch (e) {
//     // eslint-disable-next-line no-console
//     console.log('%cError on cache reset (login)', 'color: orange;', e.message)
//   }
// }

// // Manually call this when user log out
// export async function onLogout (apolloClient) {
//   localStorage.removeItem(AUTH_TOKEN)
//   if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
//   try {
//     await apolloClient.resetStore()
//   } catch (e) {
//     // eslint-disable-next-line no-console
//     console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
//   }
// }
